import { render, staticRenderFns } from "./btn-whatsapp.vue?vue&type=template&id=777be5c7"
import script from "./btn-whatsapp.vue?vue&type=script&lang=js"
export * from "./btn-whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports